import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const routes = {
    path: '',
    component: () =>
        import('../../../layouts/main/Main.vue'),
    children: [
        {
            path: '/patient-data/:id',
            name: 'patient-data',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()
            },
            component: () =>
                import('./PatientData/PatientData.vue'),
        },
        {
            path: '/patient-attendance/:id',
            name: 'patient-attendance',
            beforeEnter: (to, from, next) => {
                const bearer = Vue.prototype.$session.get("bearer");
                const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                Vue.prototype.$session.set("bearer", bearerDefault);
                let isAuthenticated = false;
                if (bearer !== null && bearer !== undefined && bearer !== "") {
                    isAuthenticated = true;
                } else {
                    isAuthenticated = false;
                }

                if (!isAuthenticated)
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                else next()
            },
            component: () =>
                import('./PatientAttendance/PatientAttendance.vue'),
        },

    ]
}
export default [
    routes
]

